export enum WhoOptionsYesNo {
    Yes = 1,
    No = 2
}
